/* @description Find an array in a JSON object
 * @param json {object} A Json object or array.
 * @param arrayName {array} The name of a key that represents an array to use. If not specified, the first array found will be returned.
 * @returns {Array} An array if found, otherwise null.
*/
export function getArray(json, arrayName) {
    if (typeof json === 'string') {
        try {
            json = JSON.parse(json);
        }
        catch (error) {
            console.error('Error parsing JSON string:', error);
            return null;
        }
    }
    if (Array.isArray(json)) {
        return json;
    }
    if (typeof json === 'object' && json !== null) {
        for (const key in json) {
            const value = json[key];
            if (Array.isArray(value)) {
                return value;
            }
            else if (typeof value === 'object') {
                const nestedResult = getArray(value, arrayName);
                if (nestedResult) {
                    return nestedResult;
                }
            }
        }
    }
    return null; // No array found
}
/* @description Perform string substitution on a template using a JSON object
*/
function interpolate(template, data) {
    try {
        return new Function("return `" + template + "`;").call(data);
    }
    catch (err) {
        document.dispatchEvent(new CustomEvent('qbo-warning', { detail: { 'error': err, 'message': 'Unable to substitute template.', 'template': template, 'data': data } }));
        return template;
    }
}
/* @description Perform string substitution of ${expression} using one or more JSON objects.
 * @example substitute('Hello ${name}!', { name: 'World' }) => 'Hello World!'
*/
function substituteOld(inputString, ...jsonData) {
    // Use a regular expression to match ${key} expressions
    const regex = /\${(.*?)}/g;
    let resultString = inputString;
    for (let i = 0; i < jsonData.length; i++) {
        const data = jsonData[i];
        resultString = resultString.replace(regex, (match, expression) => {
            const parts = expression.split('|');
            const key = parts[0].trim();
            const format = (parts.lenth > 1) ? parts[1].trim() : null;
            // todo: handle formatting (dates, currency, etc.)
            const replacement = data[key];
            // If the key exists in the JSON data, replace it; otherwise, keep the original string
            return replacement !== undefined ? replacement : match;
        });
    }
    resultString = resultString.replace(regex, () => '');
    return resultString;
}
export function substitute(inputString, ...jsonData) {
    // Use a regular expression to match ${key} expressions
    const regex = /\${(.*?)}/g;
    let resultString = inputString;
    for (let i = 0; i < jsonData.length; i++) {
        const data = jsonData[i];
        resultString = resultString.replace(regex, (match, expression) => {
            const parts = expression.split(/\.|\[|\]/).filter(part => part !== '');
            let currentValue = data;
            // Iterate over the parts to access the desired value
            for (let part of parts) {
                if (currentValue[part] === undefined)
                    return match;
                currentValue = currentValue[part];
            }
            return currentValue;
        });
    }
    resultString = resultString.replace(regex, () => '');
    return resultString;
}
/* @description Replicates content in a target element for each item in a JSON array.
*/
export function replicate(target, template, sourceData, emptyContent = true) {
    if (target != null && template != null) {
        while (emptyContent && target.firstChild) {
            target.removeChild(target.firstChild);
        }
        sourceData.map((data, index) => {
            const row = template.content.cloneNode(true);
            if (row.firstElementChild != null) {
                row.firstElementChild.setAttribute("data-index", `${index}`);
                row.firstElementChild.innerHTML = substitute(row.firstElementChild?.innerHTML ?? '', data);
            }
            target.appendChild(row);
        });
    }
}
